import type { ReactNode } from "react";

export interface Tab {
  id: string;
  label: string;
}

/**
 * Écran une-page : titre + onglets figés, contenu scrollable *à l'intérieur*
 * uniquement. Le shell de l'app ne défile jamais.
 */
export function Screen({
  title,
  subtitle,
  action,
  tabs,
  activeTab,
  onTab,
  children,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  tabs?: Tab[];
  activeTab?: string;
  onTab?: (id: string) => void;
  children: ReactNode;
}) {
  return (
    <div className="mx-auto flex h-full max-w-3xl flex-col px-5 sm:px-6">
      <div className="flex shrink-0 items-start justify-between gap-3 pt-5">
        <div className="min-w-0">
          {typeof title === "string" ? (
            <h1 className="truncate font-serif text-2xl text-stone-900">{title}</h1>
          ) : (
            title
          )}
          {subtitle && <div className="mt-0.5 text-sm text-stone-500">{subtitle}</div>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>

      {tabs && (
        <div className="sv-scroll mt-4 flex shrink-0 gap-1 rounded-full bg-stone-100 p-1">
          {tabs.map((t) => (
            <button
              key={t.id}
              onClick={() => onTab?.(t.id)}
              className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition ${
                activeTab === t.id
                  ? "bg-white text-stone-900 shadow-sm"
                  : "text-stone-500 hover:text-stone-800"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      )}

      <div className="sv-scroll -mx-1 min-h-0 flex-1 px-1 py-4">{children}</div>
    </div>
  );
}
